// extracted by mini-css-extract-plugin
export var mt0 = "navigation-module--mt-0--5b08c";
export var mt1 = "navigation-module--mt-1--a4e4f";
export var mt2 = "navigation-module--mt-2--24ae0";
export var mt3 = "navigation-module--mt-3--3e50f";
export var mt4 = "navigation-module--mt-4--176d1";
export var mt5 = "navigation-module--mt-5--516ef";
export var mt6 = "navigation-module--mt-6--77e0f";
export var navigation = "navigation-module--navigation--db942";
export var navigationSticky = "navigation-module--navigation--sticky--c1fc4";